import { useState, type FormEvent } from "react";
import { api, guardarToken } from "../api.js";

export function Entrar({ aoEntrar }: { aoEntrar: () => void }): JSX.Element {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent): Promise<void> {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      const r = await api.entrar(email.trim(), senha);
      guardarToken(r.token);
      aoEntrar();
    } catch (x) {
      setErro(x instanceof Error ? x.message : "Não foi possível entrar.");
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="min-h-full grid place-items-center px-5 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <div className="inline-grid place-items-center size-11 rounded-xl bg-marca text-white font-bold tracking-tight mb-4">
            AD
          </div>
          <h1 className="text-2xl font-semibold tracking-tight">AutoDis</h1>
          <p className="text-tinta-2 text-sm mt-1">
            Incubadora de Números e Disparadora de Campanhas
          </p>
        </div>

        <form
          onSubmit={(e) => void enviar(e)}
          className="bg-superficie border border-linha rounded-2xl p-6 shadow-sm"
        >
          <label className="block mb-4">
            <span className="block text-xs font-medium text-tinta-2 mb-1.5">
              E-mail
            </span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-linha bg-superficie-2 px-3 py-2.5 text-sm outline-none focus:border-marca"
            />
          </label>

          <label className="block mb-5">
            <span className="block text-xs font-medium text-tinta-2 mb-1.5">
              Senha
            </span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="w-full rounded-lg border border-linha bg-superficie-2 px-3 py-2.5 text-sm outline-none focus:border-marca"
            />
          </label>

          {erro && (
            <div
              role="alert"
              className="mb-4 rounded-lg bg-crit-suave border border-crit/25 text-crit px-3 py-2.5 text-sm"
            >
              {erro}
            </div>
          )}

          <button
            type="submit"
            disabled={enviando}
            className="w-full rounded-lg bg-marca text-white font-medium text-sm py-2.5 hover:bg-marca-2 disabled:opacity-55 transition-colors"
          >
            {enviando ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
